import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class LoadingComponent {
  @Input() bar = false;
  @Input() button = false;
  @Input() center = false;
  @Input() innerClass = '';
}
